/**
 *
 * Asynchronously loads the ScheduleApplicantCancelModal component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
